//VARIANT PACK CLICK EVENT JS START
jQuery(document).on("click",".product_custom_variant .custom_variant_col",function(){
    jQuery('.product_custom_variant .custom_variant_col').find('.custom_variant_box').removeClass('active');
    jQuery(this).find('.custom_variant_box').addClass('active');
    packwiseProgressbar();
    packWiseQuantityInput();
});
//VARIANT PACK CLICK EVENT JS END

// Initialize progress UI on page load
jQuery(function(){
  try { packwiseProgressbar(); } catch(e) { /* noop */ }
});

//PACK WISE PROGRESS BAR FILLED JS START
function packwiseProgressbar(){
    if(jQuery('.product_custom_variant .custom_variant_col').find('.custom_variant_box.active').length>0){
    var getPack = jQuery('.product_custom_variant .custom_variant_col').find('.custom_variant_box.active').attr('data-pack');
    var packCount = parseInt(getPack, 10) || 0;
        if(getPack!="" && getPack!=undefined){
            if(jQuery('.product_bundle_progress').find('.pb_progress_steps').length>0){
                var progressObj = jQuery('.product_bundle_progress').find('.pb_progress_steps');
                var freeProductCol = jQuery('.product_bundle_block').find('.product_bundle_grid');
                progressObj.find('.pb_progress_step').removeClass('one two');
                freeProductCol.find('.product_bundle_col').removeClass('free-active');
        if(packCount>1){
          for(var g=0;g<packCount;g++){
                        if(g==0 && getPack==2){
                            progressObj.find('.pb_progress_step').eq(g).addClass('one two');
                            freeProductCol.find('.product_bundle_col').eq(g).addClass('free-active');
                        }else if(getPack==2){
                            progressObj.find('.pb_progress_step').eq(g).addClass('one');
                            freeProductCol.find('.product_bundle_col').eq(g).addClass('free-active');
                        }else{
                            progressObj.find('.pb_progress_step').addClass('one two');
                            
                        }
                    }
                    if(getPack == 3){
                      freeProductCol.find('.product_bundle_col').addClass('free-active');
                    }
                }
                
            }

      // Dynamic message update per step (3-step model)
      var $bundleProgress = jQuery('.product_bundle_progress');
      var $msg = $bundleProgress.find('.pb_progress_message');
      if($msg.length){
        // thresholds for 3 steps (1, 2, 3 packs)
        var thresholds = [1,2,3];
        var labels = [
          $bundleProgress.attr('data-label-step1') || 'Step 1',
          $bundleProgress.attr('data-label-step2') || 'Step 2',
          $bundleProgress.attr('data-label-step3') || 'Step 3'
        ];

        var nextIndex = -1;
        for(var i=0;i<thresholds.length;i++){
          if(packCount < thresholds[i]){ nextIndex = i; break; }
        }

        if(nextIndex === -1){
          // all unlocked
          $msg.html('<b>🎉 Congrats!</b> You have unlocked all gifts.');
        } else {
          var remaining = Math.max(1, thresholds[nextIndex] - packCount);
          var label = labels[nextIndex];
          $msg.html('🔒 Add ' + remaining + ' more to unlock <b>' + label + '</b>');
        }
      }
        }
    }
}
//PACK WISE PROGRESS BAR FILLED JS START END

//PDP PAGE FOR CUSTOM BUNDLE WISE PRODUCT QTY ADD JS START
jQuery(document).ready(function(){
  setTimeout(function(){
    packWiseQuantityInput();
  },1000);
});

function packWiseQuantityInput() {
  if (jQuery('.product-information').find('.product_custom_variant').length > 0) {
    console.log("iiiiiii forms");

    var packQty = jQuery('.product-information')
      .find('.product_custom_variant .custom_variant_box.active')
      .attr('data-qty') || 1;

    var formSelectors = 'form[action*="/cart/add"], form.product-form, form#AddToCartForm';

    jQuery(formSelectors).each(function () {
      var $form = jQuery(this);

      // find existing quantity inputs
      var $qtyInput = $form.find('input[name="quantity"], input.quantity, input[type="number"][name^="quantity"]');

      if ($qtyInput.length > 0) {
        // ✅ if exists — just update the value
        $qtyInput.val(packQty);
        console.log('Updated existing quantity to ' + packQty);
      } else {
        // 🚀 if not exists — create hidden input
        $form.append('<input type="hidden" name="quantity" value="' + packQty + '" class="injected-hidden-quantity" />');
        console.log('Injected hidden quantity (' + packQty + ') into product form.');
      }
    });
  }
}

//PDP PAGE FOR CUSTOM BUNDLE WISE PRODUCT QTY ADD JS END

// ADD TO CART JS START
jQuery(document).on("click",".product-atc-button-wrapper .add-to-cart-button",function(){
    var variantId = jQuery(this).attr('data-vid');
    if(variantId!="" && variantId!=undefined){
        jQuery(this).addClass('btn--loading');
        landingProductATC(variantId);
    }
});
// ADD TO CART JS END

// function landingProductATC(variantId) {
//   var getPack = jQuery('.product_custom_variant .custom_variant_col')
//     .find('.custom_variant_box.active')
//     .attr('data-pack');

//   var getQty = jQuery('.product_custom_variant .custom_variant_col')
//     .find('.custom_variant_box.active')
//     .attr('data-qty');

//   var itemData = {
//     id: variantId,
//     quantity: getQty,
//     properties: { '__pack': getPack }
//   };

//   $.ajax({
//     type: "POST",
//     url: "/cart/add.js",
//     data: JSON.stringify(itemData),
//     dataType: "json",
//     contentType: "application/json",
//     success: function (data) {
//       window.location.href="/checkout";

//     },
//     error: function (xhr, textStatus) {
//       if(jQuery(".product-atc-button-wrapper").find(".add-to-cart-button").length>0){
//         jQuery(".product-atc-button-wrapper").find(".add-to-cart-button").removeClass('btn--loading');
//       }
//       console.error("Error:", textStatus, xhr.responseText);
//       alert("Error adding to cart: " + xhr.statusText);
//     },
//   });
// }

// Toggle this on when debugging to see detailed console output
const VOLUME_DEBUG = true;

// How long to wait for the dynamic discount code (total)
const DISCOUNT_TIMEOUT_MS = 5000; // 5s
// Polling backoff parameters
const INITIAL_POLL_MS = 150;
const MAX_POLL_MS = 800;

/**
 * Small helper to sleep
 */
function sleep(ms) {
  return new Promise((res) => setTimeout(res, ms));
}

/**
 * Try to get a discount code once from any available source.
 * Return a string code or null.
 */
async function tryGetVolumeCodeOnce() {
  // Source 1: BoGOS global API
  try {
    if (window.bogos && typeof window.bogos.getDiscountCode === 'function') {
      const code = await window.bogos.getDiscountCode();
      if (VOLUME_DEBUG) console.debug('[VOLUME] bogos.getDiscountCode() ->', code);
      if (code) return code;
    }
  } catch (e) {
    if (VOLUME_DEBUG) console.warn('[VOLUME] bogos.getDiscountCode() threw:', e);
  }

  // Source 2: Active variant element attribute
  try {
    const el = document.querySelector('.custom_variant_box.active[data-discount-code]');
    if (el) {
      const code = el.getAttribute('data-discount-code');
      if (VOLUME_DEBUG) console.debug('[VOLUME] data-discount-code from DOM ->', code);
      if (code) return code;
    }
  } catch (e) {
    if (VOLUME_DEBUG) console.warn('[VOLUME] DOM discount code lookup threw:', e);
  }

  // Source 3: App endpoint
  try {
    const res = await fetch('/apps/bogos/v1/volume-code', { credentials: 'same-origin' });
    if (res.ok) {
      const json = await res.json().catch(() => ({}));
      if (VOLUME_DEBUG) console.debug('[VOLUME] endpoint /apps/bogos/v1/volume-code ->', json);
      if (json && json.code) return json.code;
    } else if (VOLUME_DEBUG) {
      console.debug('[VOLUME] endpoint non-200', res.status);
    }
  } catch (e) {
    if (VOLUME_DEBUG) console.warn('[VOLUME] endpoint fetch threw:', e);
  }

  return null;
}

/**
 * Poll for a volume discount code until timeout. Returns code or null.
 */
async function getVolumeCodeWithRetries(timeoutMs = DISCOUNT_TIMEOUT_MS) {
  const start = Date.now();
  let delay = INITIAL_POLL_MS;

  while (Date.now() - start < timeoutMs) {
    const code = await tryGetVolumeCodeOnce();
    if (code && typeof code === 'string' && code.trim()) {
      return code.trim();
    }
    if (VOLUME_DEBUG) console.debug('[VOLUME] code not ready, polling again in', delay, 'ms');
    await sleep(delay);
    delay = Math.min(Math.floor(delay * 1.7), MAX_POLL_MS);
  }

  return null;
}

/**
 * Optional: confirm cart has the newly added line before requesting code.
 * Not strictly required, but can reduce races on some setups.
 */
async function ensureCartUpdated() {
  try {
    const res = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (res.ok) {
      const cart = await res.json();
      if (VOLUME_DEBUG) console.debug('[VOLUME] /cart.js line_count:', cart.item_count);
    }
  } catch (e) {
    if (VOLUME_DEBUG) console.warn('[VOLUME] ensureCartUpdated error:', e);
  }
}

/**
 * Main ATC flow with robust discount application
 */
async function landingProductATC(variantId) {
  // Validate selection
  const active = jQuery('.product_custom_variant .custom_variant_col').find('.custom_variant_box.active').get(0);
  if (!active) {
    alert('Please select a pack option first.');
    if (VOLUME_DEBUG) console.warn('[VOLUME] No active .custom_variant_box');
    return;
  }

  const getPack = active.getAttribute('data-pack') || '';
  const qtyAttr = active.getAttribute('data-qty');
  const getQty = Number.parseInt(qtyAttr, 10);
  const quantity = Number.isFinite(getQty) && getQty > 0 ? getQty : 1;

  const itemData = {
    id: variantId,
    quantity: quantity,
    properties: { '__pack': getPack }
  };

  const $btn = jQuery('.product-atc-button-wrapper .add-to-cart-button');

  try {
    $btn.addClass('btn--loading');

    // Add to cart
    if (VOLUME_DEBUG) console.debug('[VOLUME] POST /cart/add.js', itemData);
    await jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: JSON.stringify(itemData),
      dataType: 'json',
      contentType: 'application/json'
    });

    // Give the app a short moment to react to the cart change
    await ensureCartUpdated();

    // Rely on theme's auto-open behavior if cart drawer present.
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: { data: { source: 'landing-atc', variantId: String(variantId) } },
      })
    );
    if (VOLUME_DEBUG) console.debug('[VOLUME] Dispatched cart:update (minimal)');
  } catch (err) {
    console.error('[VOLUME] ATC error:', err);
    alert('Error adding to cart. Please try again.');
  } finally {
    $btn.removeClass('btn--loading');
  }
}

// If you need to use this in HTML onclick, expose globally:
window.landingProductATC = landingProductATC;

//PACK WISE PROGRESS BAR FILLED JS END

//TIMER JS START
jQuery(function($) {
  // 7-hour timer with initial visible start at 06:48:32.
  const CYCLE_DURATION_MS = 7 * 60 * 60 * 1000; // 7 hours in ms
  const START_AT_MS = ((6 * 60 * 60) + (48 * 60) + 32) * 1000; // 06:48:32 in ms
  const STORAGE_KEY = 'offer_timer_end_time'; // session-based per visit

  // To start again at 06:48:32 (instead of full 7h), set to true
  const ALWAYS_START_AT_OFFSET = false;

  const $wrapper = $('.product-atc-button-wrapper');
  if ($wrapper.find('.offer-timmer').length > 0) {
    const $timerDisplay = $wrapper.find('.offer-timmer');

    /**
     * @param {number} msFromNow
     */
    function setEndTime(msFromNow) {
      const end = Date.now() + msFromNow;
      sessionStorage.setItem(STORAGE_KEY, String(end));
      return end;
    }

    function ensureEndTime() {
      let end = sessionStorage.getItem(STORAGE_KEY);
      if (!end) {
        // First load this session → start at 06:48:32 remaining (within the 7h cycle)
        end = String(setEndTime(Math.min(START_AT_MS, CYCLE_DURATION_MS)));
      }
      return Number(end);
    }

    /**
     * @param {number} ms
     */
    function formatTime(ms) {
      const totalSeconds = Math.max(0, Math.floor(ms / 1000));
      const hours = Math.floor((totalSeconds / 3600));
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      return (
        String(hours).padStart(2, '0') + ':' +
        String(minutes).padStart(2, '0') + ':' +
        String(seconds).padStart(2, '0')
      );
    }

    // Initialize end time
    ensureEndTime();

    function tick() {
      let end = Number(sessionStorage.getItem(STORAGE_KEY));
      const now = Date.now();
      let remaining = end - now;

      if (remaining <= 0) {
        // Cycle complete → start a new cycle
        const nextDuration = ALWAYS_START_AT_OFFSET ? Math.min(START_AT_MS, CYCLE_DURATION_MS) : CYCLE_DURATION_MS;
        end = setEndTime(nextDuration);
        remaining = end - now;
      }

      $timerDisplay.text(formatTime(remaining));
    }

    // Initial paint and schedule updates once per second
    tick();
    setInterval(tick, 1000);
  }
});


//TIMER JS END



document.addEventListener('DOMContentLoaded', function() {
  const variantBoxes = document.querySelectorAll('.custom_variant_box');
  const productPriceEl = document.querySelector('.product-price');

  if (!variantBoxes.length || !productPriceEl) return;

  const originalPriceEl = productPriceEl.querySelector('.original-price');
  const regularPriceEl = productPriceEl.querySelector('.regular-price');
  const discountEl = productPriceEl.querySelector('.price-discount');

  const initialPriceState = {
    original: originalPriceEl ? originalPriceEl.textContent.trim() : '',
    regular: regularPriceEl ? regularPriceEl.textContent.trim() : '',
    discount: discountEl ? discountEl.textContent.trim() : ''
  };

  function formatMoney(value) {
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    return `$${num.toFixed(2)}`;
  }

  variantBoxes.forEach(box => {
    box.addEventListener('click', () => {
      variantBoxes.forEach(b => b.classList.remove('active'));
      box.classList.add('active');

      const isSingle = box.dataset.pack === '1';

      if (isSingle) {
        // Reset to original prices
        if (originalPriceEl) {
          originalPriceEl.textContent = initialPriceState.original;
          originalPriceEl.style.display = initialPriceState.original ? 'inline' : 'none';
        }
        if (regularPriceEl) {
          regularPriceEl.textContent = initialPriceState.regular;
        }
        if (discountEl) {
          discountEl.textContent = initialPriceState.discount;
          discountEl.style.display = initialPriceState.discount ? 'inline' : 'none';
        }
        return;
      }

      // Get prices from data attributes
      const compare = box.dataset.compare;
      const price = box.dataset.price;

      // Get SAVE text from the box
      const saveLabel = box.querySelector('.cv_save_label');
      const saveText = saveLabel ? saveLabel.textContent.trim() : '';

      if (originalPriceEl) {
        originalPriceEl.textContent = formatMoney(compare);
        originalPriceEl.style.display = 'inline';
      }
      if (regularPriceEl) {
        regularPriceEl.textContent = formatMoney(price);
      }
      if (discountEl) {
        discountEl.textContent = saveText;
        discountEl.style.display = saveText ? 'inline' : 'none';
      }
    });
  });
});
